module.exports = __webpack_public_path__ + "img/logo-wording.ee388f16.svg";